import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface SurveysTabState {

  showOverlay: boolean;
};

const initialState: SurveysTabState = {

    showOverlay: false,
};

const surveyTabSlice = createSlice({
  name: "surveysTab",
  initialState,
  reducers: {
    setShowOverlay: (state, action: PayloadAction<boolean>) => {
      state.showOverlay = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Add extra reducers here
  },
});

export const {  setShowOverlay } = surveyTabSlice.actions;
export const selectLeftView = (state: any) => state.surveysTab;
export default surveyTabSlice.reducer;